var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRotateLeft = function SvgRotateLeft(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 20,
    viewBox: "0 0 19.8 20.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.3 4.074a.7.7 0 0 1 .7-.7h4c3.7 0 6.7 3 6.7 6.7v2a.7.7 0 1 1-1.4 0v-2a5.3 5.3 0 0 0-5.3-5.3H9a.7.7 0 0 1-.7-.7",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M11.212 7.546 7.889 4.259l-.031-.04a.26.26 0 0 1-.002-.283l.032-.04L11.174.576a.25.25 0 0 1 .356.351l-3.116 3.15 3.15 3.115a.25.25 0 0 1-.352.355Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 10.474H2a.6.6 0 0 0-.6.6v7a.6.6 0 0 0 .6.6h7a.6.6 0 0 0 .6-.6v-7a.6.6 0 0 0-.6-.6m-7-1.4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRotateLeft);
export default ForwardRef;